import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  ResetPasswordFormFields,
  validationSchema,
} from 'shared/types/reset-password-form';

export const useResetPasswordForm = (
  submit: (forgotPasswordData: ResetPasswordFormFields) => void,
) => {
  const { handleSubmit, ...formProps } = useForm<ResetPasswordFormFields>({
    resolver: yupResolver(validationSchema),
    mode: 'onSubmit',
  });

  const onSubmit = handleSubmit((data) => submit(data));

  return {
    ...formProps,
    onSubmit,
    errors: formProps.formState.errors,
    isValid: formProps.formState.isValid,
  };
};
